import {NgModule} from '@angular/core';
import {LaunchpadModule} from "./launchpad/launchpad.module";

@NgModule({
    exports: [
        LaunchpadModule
    ],
    imports: []
})
export class FeatureLaunchpadModule {
}
